module.exports = __webpack_public_path__ + "img/levelup-circle.60522397.svg";